<template>
  <div class="skeleton mobile-carousel">
    <div class="mobile-carousel__tile skeleton__animate">
      <p class="skeleton__animate--white mobile-carousel__title"></p>
      <p class="skeleton__animate--white mobile-carousel__bottom"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileCarouselSkel',
}
</script>

<style lang="scss" scoped>
.mobile-carousel {
  padding: 0 0 50px 0;
  &__tile {
    height: 250px;
    padding: 10px;
    width: 100%;
    position: relative;
  }
  &__title {
    margin: 30px 10px 0 10px;
    width: 220px;
    height: 18px;
  }
  &__bottom {
    position: absolute;
    bottom: 15px;
    left: 10px;
    height: 18px;
    width: 100px;
  }
}
</style>
